import React from 'react';
import styles from './EditShipmentFooter.module.css';

interface EditShipmentFooterProps {
  onSave: () => void;
  onCancel: () => void;
  disabled?: boolean;
}

/** Save and Cancel at the bottom of the edit drawer (Figma 45930:22804). */
const EditShipmentFooter: React.FC<EditShipmentFooterProps> = ({
  onSave,
  onCancel,
  disabled = false,
}) => (
  <div className={styles.footer}>
    <button
      type='button'
      className={styles.save}
      onClick={onSave}
      disabled={disabled}
    >
      Save
    </button>
    <button type='button' className={styles.cancel} onClick={onCancel}>
      Cancel
    </button>
  </div>
);

export default EditShipmentFooter;
